/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HirePapiProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Import an applicant from Hire to WX
   * @param xFountainPartnerSignature
   * @param requestBody
   * @returns any Applicant successfully imported
   * @throws ApiError
   */
  public postApiServicesecurityProcessesHirePapiApplicantWebhook(
    xFountainPartnerSignature: string,
    requestBody: {
      applicant?: Record<string, any>;
    },
  ): CancelablePromise<{
    /**
     * URL to redirect the user to
     */
    redirect_url?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/hire/papi/applicantWebhook',
      headers: {
        'x-fountain-partner-signature': xFountainPartnerSignature,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
